export function register() {

  if ('serviceWorker' in navigator ) {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registrado:', registration);

        // Atualização automática quando novo service worker estiver pronto
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
              window.location.reload();
            }
          });
        });
      })
      .catch((error) => {
        console.error('Falha no registro do SW:', error);
      });

    // Verificar atualizações periodicamente
    navigator.serviceWorker.ready.then((registration) => {
      setInterval(() => registration.update(), 60 * 60 * 1000); // Checar atualizações a cada 1 hora
    });
  }
}